import { Parameter } from "../../components/atoms/FormInputs/ParametersForm/types";
import { FlowioFunctionId, Dictionary, TemplateId } from "../../globalTypes";

export type DataSourceAPI = {
  id: number;
  name: string;
  serverName: string;
  dbName: string;
  dbLogin: string;
  dbPassword: string;
  isHeg: boolean;
  wsUrl: string;
  wsProfile: string;
  hash: string;
};

export enum FunctionType {
  DB = "db",
  HEG = "heg",
  HegWorkflow = "hegWorkflow",
}

export enum WorkflowCommentTypeAPI {
  None = "none",
  Required = "required",
  Optional = "optional",
}

export type FunctionAPI = {
  id: FlowioFunctionId;
  name: string;
  column: string;
  type: FunctionType;
  paramsJson: string | null;
  functionID: number;
  entryFunction: boolean;
  parentColumn: string;
  dataSourceId: number;
  datasource: DataSourceAPI;
  datasourceName: string;
  isCommon: boolean;
  workflowCommentType: WorkflowCommentTypeAPI;
};

export type RunFunctionResponse = {
  state: number;
  stateText: string;
  exceptionText: string;
  message: string;
  resultState?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  returnValue: any;
};

export type RunFunctionDTO = {
  functionId: FlowioFunctionId;
  templateId: TemplateId;
  itemKeyValue: number | string | null;
  parentKeyValue?: number | string | null;
  userLogin?: string;
  hegParameters?: RunFunctionParameters;
  workflowComment?: string;
  isImpersonating?: boolean | null;
};

export type RunCommonFunctionDTO = Omit<
  RunFunctionDTO,
  "itemKeyValue" | "workflowComment"
>;

export type FunctionParametersVal = string | number | boolean | null;

export type RunFunctionParameters = Dictionary<string, FunctionParametersVal>;

export type FunctionPatchDTO = {
  name: string;
  column: string;
  type: FunctionType;
  isCommon: boolean;
  entryFunction: boolean;
  parentColumn: string;
  datasourceID: number;
  paramsJson: string;
  workflowCommentType: WorkflowCommentTypeAPI;
  translationsJSON: string;
};

export type ImportUsersParams = Pick<
  RunFunctionDTO,
  "functionId" | "hegParameters"
>;

export type DeleteResponse = {
  isDeleted: boolean;
  activeTemplateIds: Record<number, string>;
  deletedTemplateIds: Record<number, string>;
};
